import { render, staticRenderFns } from "./DisplayGrid.vue?vue&type=template&id=ef066d2a&scoped=true&"
import script from "./DisplayGrid.vue?vue&type=script&lang=js&"
export * from "./DisplayGrid.vue?vue&type=script&lang=js&"
import style0 from "./DisplayGrid.vue?vue&type=style&index=0&id=ef066d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef066d2a",
  null
  
)

export default component.exports